import Vue from 'vue'
import Vuex from 'vuex'
import PageConfigs from '@/store/modules/PageConfigs'

Vue.use(Vuex)
const store = new Vuex.Store({
  modules: {
    PageConfigs
  }
})
export default store
